module.exports = __webpack_public_path__ + "img/vehicle.5a7133b4.png";